import { render, staticRenderFns } from "./BeneficiarioMain.vue?vue&type=template&id=5124aa21"
import script from "./BeneficiarioMain.vue?vue&type=script&lang=js"
export * from "./BeneficiarioMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports